var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDosanitariatwIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.63 53.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0085c3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ikony"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.84,53.52h18.82c.87,0,1.57-.7,1.57-1.57s-.7-1.57-1.57-1.57h-4.7v-3.14h-9.41v3.14h-4.7c-.87,0-1.57.7-1.57,1.57s.7,1.57,1.57,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.29,22.84c-.56-.97-2.16-.97-2.72,0l-2.72,4.71c-.41.71-.63,1.53-.63,2.35,0,2.59,2.11,4.7,4.7,4.7s4.7-2.11,4.7-4.7c0-.82-.22-1.63-.63-2.35l-2.72-4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.54,12.54v18.92h9.41V12.54c0-1.73,1.41-3.14,3.14-3.14s3.14,1.41,3.14,3.14v4.81c0,.87.7,1.57,1.57,1.57h6.27c.87,0,1.57-.7,1.57-1.57v-4.81c0-6.92-5.63-12.54-12.54-12.54s-12.54,5.63-12.54,12.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.7,44.11h4.7v-9.51l-3.17-14.42c-.15-.73-.79-1.26-1.54-1.26H1.57c-.87,0-1.57.7-1.57,1.57v18.92c0,2.59,2.11,4.7,4.7,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.09,42.54v-6.38c0-.87-.7-1.57-1.57-1.57h-10.98v9.51h10.98c.87,0,1.57-.7,1.57-1.57Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDosanitariatwIcon);
export default __webpack_public_path__ + "static/media/Do sanitariatów_icon.08cc1c2bbd8f924220662dc2e271705a.svg";
export { ForwardRef as ReactComponent };